// extracted by mini-css-extract-plugin
export default {"iconList":"customerJourneyVisualizationIconPicker_iconList__B-H22"};